import { all, call, put, fork, takeEvery } from "redux-saga/effects";

import { STRIPE_GET_CONTACT_INFO, STRIPE_CLEAR_DATA } from "../actions";

import {
  getContactInfoStripeSuccess,
  getContactInfoStripeError,
} from "./actions";

//! 1. Our worker saga

//* GET CONTACT INFO from Stripe // ---------------------------------------------------------------------------------------------
const getContactInfoStripeRequest = async (payload) => {
  //console.log(payload.payload);

  let contactId = payload.payload;

  return await fetch(`/mick/stripe/subscription`, {
    method: "get",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((result) => {
      //console.log(result);
      return result;
    });
};

function* getContactInfoStripe(payload) {
  try {
    const response = yield call(getContactInfoStripeRequest, payload);

    yield put(getContactInfoStripeSuccess(response));
  } catch (error) {
    yield put(getContactInfoStripeError(error));
  }
}

//* CLEAR STRIPE DATA // ---------------------------------------------------------------------------------------------

function clearDataStripe({ payload }) {
  const { history } = payload;
}

//!2. Our watcher saga
// our watcher saga spawn a new task on each action

export function* watchGetContactInfoStripe() {
  yield takeEvery(STRIPE_GET_CONTACT_INFO, getContactInfoStripe);
}

export function* watchClearDataStripe() {
  yield takeEvery(STRIPE_CLEAR_DATA, clearDataStripe);
}

//!3. Our root saga
// single entry point to start sagas at once

export default function* rootSaga() {
  yield all([fork(watchGetContactInfoStripe), fork(watchClearDataStripe)]);
}
